<template>
  <v-list three-line class="notifications-list">
    <p v-if="!list.length">Для вас поки що немає сповіщень</p>
    <template v-else>
      <v-list-tile
        avatar
        v-for="(item, index) in list"
        :key="item.id"
        @click="toggle(item.id)"
        :class="{ expanded: itemExpanded[item.id], unread: !item.read }"
      >
        <v-list-tile-avatar>
          <img v-if="item.data.user.photoUrl" :src="item.data.user.photoUrl">
          <v-icon v-else x-large class="default-avatar">account_circle</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <template v-if="item.type === 'commentAdded'">
            <v-list-tile-title >
              {{ item.data.user.name }} коментує пост <a :href="item.data.post.alias" target="_blank">{{ item.data.post.title }}</a></strong>
            </v-list-tile-title>
            <v-list-tile-sub-title>{{ item.data.comment.text }}</v-list-tile-sub-title>
          </template>
          <template v-if="item.type === 'postAdded'">
            <v-list-tile-title >
              {{ item.data.user.name }} додає пост <a :href="item.data.post.alias" target="_blank">{{ item.data.post.title }}</a></strong>
            </v-list-tile-title>
          </template>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
</template>

<script>

import Vue from 'vue';

import LinkToPost from '@/components/LinkToPost';

export default {
  name: 'NotificationsList',
  components: {
    LinkToPost,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      itemExpanded: {},
    };
  },
  methods: {
    toggle(id) {
      Vue.set(this.itemExpanded, id, !this.itemExpanded[id]);
    },
  },
};

</script>

<style scoped>

.unread {
  background: #e0ebef;
}

</style>


<style>

.notifications-list .list__tile {
  height: auto;
  min-height: 65px;
}

.notifications-list.list--three-line .list__tile {
  align-items: flex-start;
}

.notifications-list.list--three-line .list__tile__avatar {
  margin-top: 13px;
}

.notifications-list .list__tile__sub-title,
.notifications-list  .list__tile__title {
  text-transform: none;
}

.notifications-list .list__tile__content {
  margin-top: 8px;
  margin-bottom: 8px;
}

.expanded .list__tile__sub-title,
.expanded .list__tile__title {
  white-space: normal;
  height: auto;
  display: block;
}


</style>



// WEBPACK FOOTER //
// src/components/NotificationsList.vue